import React from 'react'

const Acc1 = () => {
    return (
        <div className='container'>
            <h1>Count number of squares in a rectangle</h1>
            <p>Given a m x n rectangle, how many squares are there in it?</p>
            <p><strong>Examples :</strong>&nbsp;</p>
            <pre><strong>Input:</strong>  m = 2, n = 2 <br />
<strong>Output: </strong>5 <br />
There are 4 squares of size 1x1 + 1 square of size 2x2 <br />.
 <br />
<strong>Input:</strong> m = 4, n = 3 <br />
<strong>Output:</strong> 20 <br />
There are 12 squares of size 1x1 +  <br />
          6 squares of size 2x2 +  <br />
          2 squares of size 3x3.</pre>
          <p><strong>Let us first solve this problem for m = n, i.e., for a square:</strong><br/>
          For m = n = 1, output: 1<br/>
          For m = n = 2, output: 4 + 1 [ 4 of size 1×1 + 1 of size 2×2 ]<br/>
          For m = n = 3, output: 9 + 4 + 1 [ 9 of size 1×1 + 4 of size 2×2 + 1 of size 3×3 ]<br/>
          For m = n = 4, output 16 + 9 + 4 + 1 [ 16 of size 1×1 + 9 of size 2×2 + 4 of size 3×3 + 1 of size 4×4 ]<br/>
          In general, it seems to be n^2 + (n-1)^2 + … 1 = n(n+1)(2n+1)/6</p>
          <p><strong>Let us solve this problem when m may not be equal to n:</strong>&nbsp;<br/>
          Let us assume that m &lt;= n</p>
             <div class="tabs">
             <p>From above explanation, we know that number of squares in a m x m matrix is m(m+1)(2m+1)/6</p>
             <p>What happens when we add a column, i.e., what is the number of squares in m x (m+1) matrix?</p>
             <p>When we add a column, number of squares increased is m + (m-1) + … + 3 + 2 + 1&nbsp;<br/>
             [ m squares of size 1×1 + (m-1) squares of size 2×2 + … + 1 square of size m x m ]&nbsp;<br/>
             Which is equal to m(m+1)/2</p>
             <p>So when we add (n-m) columns, total number of squares increased is (n-m)*m(m+1)/2.<br/>
             So total number of squares is m(m+1)(2m+1)/6 + (n-m)*m(m+1)/2.<br/>
             Using same logic we can prove when n &lt;= m.</p>
             <p>So, in general,&nbsp;</p>
             <pre>Total number of squares = m x (m+1) x (2m+1)/6 + (n-m) x m x (m+1)/2 <br /><br />

when n is larger dimension</pre>
<p>Using above logic for rectangle, we can also prove that number of squares in a square is n(n+1)(2n+1)/6</p>

    <input type="radio" name="tab" id="tab1" />
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>
    <input type="radio" name="tab" id="tab4"/>
    <label for="tab4">C</label>

  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C++ program to count squares</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// in a rectangle of size m x n</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;iostream&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="comments">// Returns count of all squares</code></div>
    <div class="line number7 index6 alt2"><code class="comments">// in a rectangle of size m x n</code></div>
    <div class="line number8 index7 alt1"><code class="color1 bold">int</code> <code
            class="plain">countSquares(</code><code class="color1 bold">int</code> <code class="plain">m, </code><code
            class="color1 bold">int</code> <code class="plain">n)</code></div>
    <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
    <div class="line number10 index9 alt1"><code class="comments">// If n is smaller, swap m and n</code></div>
    <div class="line number11 index10 alt2"><code class="keyword bold">if</code> <code class="plain">(n &lt; m)</code>
    </div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">swap(m, n);</code></div>
    <div class="line number13 index12 alt2">&nbsp;</div>
    <div class="line number14 index13 alt1"><code class="comments">// Now n is greater dimension,</code></div>
    <div class="line number15 index14 alt2"><code class="comments">// apply formula</code></div>
    <div class="line number16 index15 alt1"><code class="keyword bold">return</code> <code
            class="plain">m * (m + 1) * (2 * m + 1) /</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">6 + (n - m) * m *(m + 1) / 2;</code></div>
    <div class="line number18 index17 alt1"><code class="plain">&#125;</code></div>
    <div class="line number19 index18 alt2">&nbsp;</div>
    <div class="line number20 index19 alt1"><code class="comments">// Driver Code</code></div>
    <div class="line number21 index20 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number22 index21 alt1"><code class="plain">&#123;</code></div>
    <div class="line number23 index22 alt2"><code class="color1 bold">int</code> <code
            class="plain">m = 4, n = 3;</code></div>
    <div class="line number24 index23 alt1"><code class="plain">cout &lt;&lt; </code><code
            class="string">"Count of squares is "</code></div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&lt;&lt; countSquares(m, n);</code></div>
    <div class="line number26 index25 alt1"><code class="plain">&#125;</code></div>
</div>
    </div>
      <div id="tab-content-2" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// Java program to count squares</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// in a rectangle of size m x n</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="keyword">class</code> <code class="plain">NooB</code></div>
    <div class="line number5 index4 alt2"><code class="plain">&#123;</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Returns count of all squares</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// in a rectangle of size m x n</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">int</code> <code class="plain">countSquares(</code><code
            class="keyword">int</code> <code class="plain">m, </code><code class="keyword">int</code> <code
            class="plain">n)</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// If n is smaller, swap m and n</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(n &lt; m)</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// swap(m, n)</code></div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">temp = m;</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">m = n;</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n = temp;</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Now n is greater dimension,</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// apply formula</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">m * (m + </code><code class="value">1</code><code
            class="plain">) * (</code><code class="value">2</code> <code class="plain">* m + </code><code
            class="value">1</code><code class="plain">) /</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="value">6</code>
        <code class="plain">+ (n - m) * m * (m + </code><code class="value">1</code><code class="plain">) / </code><code
            class="value">2</code><code class="plain">;</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Driver Code</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String[] args)</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">m = </code><code class="value">4</code><code
            class="plain">, n = </code><code class="value">3</code><code class="plain">;</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Count of squares is "</code> <code
            class="plain">+</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">countSquares(m, n));</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number33 index32 alt2"><code class="plain">&#125;</code></div>
</div>
       </div> 
      <div id="tab-content-3" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Python3 program to count squares</code></div>
    <div class="line number2 index1 alt1"><code class="comments"># in a rectangle of size m x n</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="comments"># Returns count of all squares</code></div>
    <div class="line number5 index4 alt2"><code class="comments"># in a rectangle of size m x n</code></div>
    <div class="line number6 index5 alt1"><code class="keyword">def</code> <code
            class="plain">countSquares(m, n):</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># If n is smaller, swap m and n</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code><code class="plain">(n &lt; m):</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp </code><code class="keyword">=</code> <code class="plain">m</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">m </code><code class="keyword">=</code> <code class="plain">n</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n </code><code class="keyword">=</code> <code class="plain">temp</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Now n is greater dimension,</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># apply formula</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">((m </code><code class="keyword">*</code> <code
            class="plain">(m </code><code class="keyword">+</code> <code class="value">1</code><code
            class="plain">) </code><code class="keyword">*</code> <code class="plain">(</code><code
            class="value">2</code> <code class="keyword">*</code> <code class="plain">m </code><code
            class="keyword">+</code> <code class="value">1</code><code class="plain">) </code><code
            class="keyword">/</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="value">6</code> <code class="keyword">+</code> <code class="plain">(n </code><code
            class="keyword">-</code> <code class="plain">m) </code><code class="keyword">*</code> <code
            class="plain">m </code><code class="keyword">*</code> <code class="plain">(m </code><code
            class="keyword">+</code> <code class="value">1</code><code class="plain">) </code><code
            class="keyword">/</code> <code class="value">2</code><code class="plain">))</code></div>
    <div class="line number18 index17 alt1">&nbsp;</div>
    <div class="line number19 index18 alt2"><code class="comments"># Driver Code</code></div>
    <div class="line number20 index19 alt1"><code class="keyword">if</code> <code class="plain">__name__</code><code
            class="keyword">=</code><code class="keyword">=</code><code class="string">'__main__'</code><code
            class="plain">:</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">m </code><code class="keyword">=</code> <code class="value">4</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">n </code><code class="keyword">=</code> <code class="value">3</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code><code class="plain">(</code><code class="string">"Count of squares is "</code>
    </div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">,countSquares(m, n))</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="comments"># This code is contributed by mits.</code></div>
</div>
    </div>
      <div id="tab-content-4" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C program to count squares</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// in a rectangle of size m x n</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="comments">// Returns count of all squares</code></div>
    <div class="line number7 index6 alt2"><code class="comments">// in a rectangle of size m x n</code></div>
    <div class="line number8 index7 alt1"><code class="color1 bold">int</code> <code
            class="plain">countSquares(</code><code class="color1 bold">int</code> <code class="plain">m, </code><code
            class="color1 bold">int</code> <code class="plain">n)</code></div>
    <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">temp;</code></div>
    <div class="line number11 index10 alt2"><code class="comments">// If n is smaller, swap m and n</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(n &lt; m)</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">temp=n;</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">n=m;</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">m=temp;</code></div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">// Now n is greater dimension,</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">// apply formula</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">m * (m + 1) * (2 * m + 1) /</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">6 + (n - m) * m *(m + 1)/ 2;</code></div>
    <div class="line number22 index21 alt1"><code class="plain">&#125;</code></div>
    <div class="line number23 index22 alt2">&nbsp;</div>
    <div class="line number24 index23 alt1"><code class="comments">// Driver Code</code></div>
    <div class="line number25 index24 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number26 index25 alt1"><code class="plain">&#123;</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">m = 4, n = 3;</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code
            class="string">"Count of squares is %d"</code><code class="plain">,countSquares(m, n));</code></div>
    <div class="line number29 index28 alt2"><code class="plain">&#125;</code></div>
    <div class="line number30 index29 alt1">&nbsp;</div>
    <div class="line number31 index30 alt2"><code class="comments">// This code is contributed by Hemant Jain.</code>
    </div>
</div>s
    </div>
     </div>
  </div>
  <br /> <br /> <br /> <br /> <br />
       
        </div>
    )
}

export default Acc1
